

import React, { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import {
  Box,
  Tabs,
  Tab,
  Typography,
  Grid,
  Paper,
  Button,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Divider,
  MenuItem,
  Popover,
  Tooltip, Menu
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useTheme } from "@mui/material/styles";
import HowToRegOutlinedIcon from "@mui/icons-material/HowToRegOutlined";
import CreateNewFolderIcon from "@mui/icons-material/CreateNewFolder";
import { Close } from "@mui/icons-material";
import ApiCallService from "../../../Service/ApiCallService";
import Spinner from "../../../components/common/Spinner";
import ReadMoreOutlinedIcon from "@mui/icons-material/ReadMoreOutlined";
import MoreVertIcon from "@mui/icons-material/MoreVert";
// import pdfUrl from "../../../images/PromotionalMaterial-YOUWAAH.pdf"
import { message } from "antd";
import mdiIcons from "@iconify-json/mdi/icons.json";
import FolderOutlined from "@mui/icons-material/FolderOutlined";
import CampaignOutlined from "@mui/icons-material/CampaignOutlined";
import RuleOutlined from "@mui/icons-material/RuleOutlined";
import SchoolOutlined from "@mui/icons-material/SchoolOutlined";
import TrendingUpOutlined from "@mui/icons-material/TrendingUpOutlined";
import EventNoteOutlined from "@mui/icons-material/EventNoteOutlined";
import GroupsOutlined from "@mui/icons-material/GroupsOutlined";
import PermMediaOutlined from "@mui/icons-material/PermMediaOutlined";
import DescriptionIcon from "@mui/icons-material/Description";
import axios from "axios";
import AddIcon from '@mui/icons-material/Add';


const ICON_OPTIONS = [
  { key: "folder", label: "General", icon: FolderOutlined },
  { key: "promotional", label: "Promotional", icon: CampaignOutlined },
  { key: "guidelines", label: "Guidelines", icon: RuleOutlined },
  { key: "educational", label: "Educational", icon: SchoolOutlined },
  { key: "marketing", label: "Marketing", icon: TrendingUpOutlined },
  { key: "program", label: "Program", icon: EventNoteOutlined },
  { key: "meeting", label: "Meeting", icon: GroupsOutlined },
  { key: "media", label: "Media", icon: PermMediaOutlined },
];

const SingleProgramPage2 = () => {
  const S3URL = "https://vmsprojectdata.s3.ap-south-1.amazonaws.com/"

  const theme = useTheme();
  const { programName } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const isLoggedIn = Boolean(
    localStorage.getItem("refreshToken") && localStorage.getItem("userId"),
  );
  const userRole = useSelector((state) => state.user?.userDetails?.userRole);
  const [programBaskets, setProgramBaskets] = useState([]);
  const [activeTile, setActiveTile] = useState(0);
  const [activeTab, setActiveTab] = useState(0);
  const [programDetails, setProgramDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [currentBasket, setCurrentBasket] = useState("");
  const [currentProgram, setCurrentProgram] = useState();

  const [selectedFolder, setSelectedFolder] = useState(null);

  const [isCreateFolderOpen, setIsCreateFolderOpen] = useState(false);
  const [folderName, setFolderName] = useState("");

  const [anchorEl, setAnchorEl] = useState(null);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [openUpdateDialog, setOpenUpdateDialog] = useState(false);
  const [visibility, setVisibility] = useState("PUBLIC");
  const [anchorE2, setAnchorE2] = useState(null);
  const [openFolderPopUp, setOpenFolderPopUp] = useState(false);
  const open = Boolean(anchorEl);
  // Icon Picker state
  const iconNames = Object.keys(mdiIcons.icons);
  const [selectedIcon, setSelectedIcon] = useState("folder");
  const [iconPickerOpen, setIconPickerOpen] = useState(false);
  const [iconSearch, setIconSearch] = useState("");
  const [selectedFile, setSelectedFile] = useState("");


  // Color picker
  const colorOptions = Object.values(theme.palette.COLORS);
  const [selectedColor, setSelectedColor] = useState(colorOptions[0]);
  const [modalOpen, setModalOpen] = useState(false);
  const tileColors = Object.values(theme.palette.tileColors);
  const tileColorsHover = Object.values(theme.palette.tileColorsHover);
  let program = location?.state?.program;

  let S3_BASE_URL = "https://vmsprojectdata.s3.ap-south-1.amazonaws.com/";
  const hideSelectors = Boolean(location?.state?.hideSelectors);
  const selectedProgramId = location?.state?.program?.id || null;
  const resolveAssetUrl = (url) => {
    if (!url) return "";
    if (url.startsWith("http://") || url.startsWith("https://") || url.startsWith("data:")) {
      return url;
    }
    const baseUrl = process.env.REACT_APP_BASE_URL || "";
    const baseNoApi = baseUrl.replace(/\/?api\/?$/, "");
    const normalized = url.startsWith("/") ? url.slice(1) : url;
    if (normalized.startsWith("profile-images/")) {
      return `${S3_BASE_URL}${normalized}`;
    }
    return url.startsWith("/") ? `${baseNoApi}${url}` : `${baseNoApi}/${url}`;
  };

  const programLogoUrl = resolveAssetUrl(
    programDetails?.program?.programLogoUrl ||
    programDetails?.program?.programLogo
  );
  const folders = Array.isArray(programDetails?.folders) ? programDetails.folders : [];
  const programUpdatedAt = programDetails?.program?.updatedAt || currentProgram?.updatedAt || null;
  const extractDayMonthFromText = (value = "") => {
    const text = String(value || "").trim();
    if (!text) return "";

    const match = text.match(
      /\b(\d{1,2})(?:st|nd|rd|th)?\s*(?:-|\/|\s)\s*(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)\b/i,
    );
    if (!match) return "";

    const day = Number(match[1]);
    const monthToken = String(match[2] || "").toLowerCase();
    const monthMap = {
      jan: 1, feb: 2, mar: 3, apr: 4, may: 5, jun: 6,
      jul: 7, aug: 8, sep: 9, oct: 10, nov: 11, dec: 12,
    };
    const month = monthMap[monthToken];
    if (!Number.isInteger(day) || day < 1 || day > 31 || !month) return "";

    return `${String(day).padStart(2, "0")}-${String(month).padStart(2, "0")}`;
  };

  const inferredDayMonthFromProgramContent = () => {
    const candidateTextList = [
      programDetails?.program?.name,
      currentProgram?.name,
      ...(Array.isArray(programDetails?.program?.promotionalMaterial)
        ? programDetails.program.promotionalMaterial.map((item) => item?.name)
        : []),
      ...(Array.isArray(programDetails?.program?.howToImplement)
        ? programDetails.program.howToImplement.map((item) => item?.name)
        : []),
      ...(Array.isArray(programDetails?.program?.programReporting)
        ? programDetails.program.programReporting.map((item) => item?.name)
        : []),
    ];

    for (const candidate of candidateTextList) {
      const parsed = extractDayMonthFromText(candidate);
      if (parsed) return parsed;
    }
    return "";
  };

  const programDayMonth =
    programDetails?.program?.programDayMonth ||
    currentProgram?.programDayMonth ||
    inferredDayMonthFromProgramContent();

  const formatProgramDayMonth = (value = "") => {
    const trimmed = String(value || "").trim();
    if (!trimmed) return "";
    const match = trimmed.match(/^(\d{1,2})-(\d{1,2})$/);
    if (!match) return trimmed;

    const day = Number(match[1]);
    const month = Number(match[2]);
    if (!Number.isInteger(day) || !Number.isInteger(month) || month < 1 || month > 12) {
      return trimmed;
    }

    const monthNames = [
      "Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
    ];
    const suffix =
      day % 10 === 1 && day !== 11
        ? "st"
        : day % 10 === 2 && day !== 12
          ? "nd"
          : day % 10 === 3 && day !== 13
            ? "rd"
            : "th";

    return `${day}${suffix} ${monthNames[month - 1]}`;
  };

  const getProgramDisplayName = (programItem = {}) =>
    String(
      programItem?.displayName ||
      programItem?.programName ||
      programItem?.name ||
      ""
    ).trim();

  const baseProgramName = getProgramDisplayName(programDetails?.program || currentProgram || {});
  const formattedProgramDayMonth = formatProgramDayMonth(programDayMonth);
  const shouldAppendProgramDate =
    Boolean(formattedProgramDayMonth) && !/\(.+\)/.test(baseProgramName);
  const programTitle = shouldAppendProgramDate
    ? `${baseProgramName} (${formattedProgramDayMonth})`
    : baseProgramName || "Program";

  useEffect(() => {
    if (!programBaskets.length) return;

    //  programId came from navigation
    if (selectedProgramId) {
      let foundBasketIndex = 0;
      let foundProgramIndex = 0;

      programBaskets.forEach((basket, bIndex) => {
        const pIndex = basket.programs.findIndex(
          (p) => p._id === selectedProgramId,
        );
        if (pIndex !== -1) {
          foundBasketIndex = bIndex;
          foundProgramIndex = pIndex;
        }
      });

      setActiveTile(foundBasketIndex);
      setActiveTab(foundProgramIndex);
    }
    //  no navigation data ? default
    else {
      setActiveTile(0);
      setActiveTab(0);
    }
  }, [programBaskets, selectedProgramId]);

  useEffect(() => {

    fetchProgramBaskets();
  }, []);


  const fetchProgramBaskets = async () => {
    try {
      setLoading(true);
      const res = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/programBaskets`,
      );
      setProgramBaskets(res?.data?.data);
    } catch (err) {
      message.error(err);
      console.error(err);
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    setCurrentBasket(programBaskets[activeTile]);
  }, [activeTile, programBaskets]);

  useEffect(() => {
    setCurrentProgram(currentBasket?.programs?.[activeTab]);
  }, [activeTab, currentBasket]);

  const fetchProgramDetails = async () => {
    if (!currentProgram?._id || !programBaskets) return;

    try {
      setLoading(true);
      let url = `${process.env.REACT_APP_BASE_URL}/programs/${currentProgram._id}`;

      // append role only if it exists
      if (userRole) {
        url += `?userRole=${userRole}`;
        // url += `?userRole=3039`;

      }

      const res = await axios.get(url);
      setProgramDetails(res?.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProgramDetails();
  }, [currentProgram]);

  const fetchFolders = async () => {
    setLoading(true);
    try {
      const res = await ApiCallService.get(
        `${process.env.REACT_APP_BASE_URL}/programs/${currentProgram._id}`,
      );
      setProgramDetails(res);
    } catch (err) {
      console.error(err);
      message.error("Failed to fetch folders");
    }
    setLoading(false);
  };

  const handleCreateFolder = async () => {
    if (!folderName.trim()) return message.error("Folder name required");
    try {
      setLoading(true);
      await ApiCallService.post(
        `${process.env.REACT_APP_BASE_URL}/programs/${currentProgram._id}/folders`,
        {
          name: folderName,
          //   userId: localStorage.getItem("userId"),
          icon: selectedIcon,
          color: selectedColor,
          visibility,
        },
      );
      setIsCreateFolderOpen(false);
      setFolderName("");
      setSelectedIcon("folder");
      setSelectedColor(colorOptions[0]);
   //   fetchFolders();
   fetchProgramDetails()
    } catch (err) {
      console.error("Error from create API", err?.response?.data?.message);
      message.error(err?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  const handleMenuOpen = (e, folder) => {
    e.stopPropagation();
    setAnchorEl(e.currentTarget);
    setSelectedFolder(folder);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleDeleteClick = () => {
    setOpenDeleteDialog(true);
    handleMenuClose();
  };

  const handleConfirmDelete = async () => {
    try {
      setOpenDeleteDialog(false);
      setSelectedFolder(null);
      setLoading(true);
      await ApiCallService.delete(
        `${process.env.REACT_APP_BASE_URL}/folders/${selectedFolder._id}`,
      );
      setOpenFolderPopUp(false)
      setAnchorEl(null);

      message.success("Folder deleted successfully");
      //fetchFolders();
         fetchProgramDetails()

    } catch (err) {
      console.error(err);
      message.error("Failed to delete folder");
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateClick = () => {
    setFolderName(selectedFolder.name);
    setSelectedIcon(selectedFolder.icon || "folder");
    setSelectedColor(selectedFolder.color || colorOptions[0]);
    setOpenUpdateDialog(true);
    handleMenuClose();
  };

  const handleUpdateFolder = async () => {
    try {
      await ApiCallService.put(
        `${process.env.REACT_APP_BASE_URL}/folders/${selectedFolder._id}`,
        {
          name: folderName,
          icon: selectedIcon,
          color: selectedColor,
          visibility,
        },
      );
      message.success("Folder updated successfully");
     // await fetchFolders();
     await fetchProgramDetails()
      setOpenUpdateDialog(false);
      setSelectedFolder(null);
      setFolderName("");
      setSelectedIcon("folder");
      setSelectedColor(colorOptions[0]);
    } catch (err) {
      console.error(err);
      message.error("Failed to update folder");
    }
  };

  const handleClick = (event) => {
    setAnchorE2(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorE2(null);
  };

  const handleCreate = () => {
    navigate("/createProgram");
    handleClose();
  };

  const handleDelete = () => {
    setOpenFolderPopUp(true);
    setAnchorE2(null);
  };

  const closeCancelDelete = () => {
    setOpenDeleteDialog(false);
  };

  const handleConfirmDeleteProgram = async () => {
    if (!programDetails.program._id) return;

    try {
      setLoading(true);

      await ApiCallService.delete(
        `${process.env.REACT_APP_BASE_URL}/programs/${programDetails.program._id}`,
      );

      message.success("Program deleted successfully");
      closeCancelDelete();
      fetchProgramBaskets()
    } catch (err) {
      console.error(err);
      message.error("Failed to delete program");
    } finally {
      setLoading(false);
    }
  };



  return (
    <Paper elevation={0} variant="pageBg" sx={{p:0, m:0}}>
  
      <Box
        sx={{
          p: { xs: 1.5, sm: 2, md: 3 },
          width: "100%",
          flex: 1,
          display: "flex",
          flexDirection: "column",
          minWidth: 0,
        }}
      >
        {" "}
        <Spinner loading={loading} />
        {!hideSelectors && (
          <>
            <Grid container spacing={3}>
              {programBaskets.length > 0 &&
                programBaskets.map((basket, index) => (
                  <Grid item xs={12} sm={6} md={2.4} key={basket._id}>
                    <Paper
                      onClick={() => {
                        setActiveTile(index);
                        setActiveTab(0);
                        setProgramDetails(null);
                      }}
                      sx={{
                        cursor: "pointer",
                        textAlign: "center",
                        p: 3,
                        fontWeight: 600,
                        borderRadius: 3,
                        backgroundColor: tileColors[index % tileColors.length],
                        border:
                          activeTile === index
                            ? `2px solid ${theme.palette.primary.main}`
                            : "none",
                        transition: "all .2s",
                        "&:hover": {
                          backgroundColor:
                            tileColorsHover[index % tileColorsHover.length],
                          transform: "translateY(-4px)",
                        },
                      }}
                    >
                      {basket.name}
                    </Paper>
                  </Grid>
                ))}
            </Grid>

            {currentBasket && (
              <Box sx={{ mt: 4 }}>
                <Tabs
                  value={activeTab}
                  onChange={(_, val) => setActiveTab(val)}
                  variant="scrollable"
                  scrollButtons="auto"
                >
                  {currentBasket.programs.map((prog) => (
                    <Tab key={prog._id} label={getProgramDisplayName(prog) || "Program"} />
                  ))}
                </Tabs>
              </Box>
            )}

          </>
        )}



        <Box sx={{ mt: 5 }}>
          <Box
            sx={{
              position: "relative",
              display: "flex",
              alignItems: "center",
              mb: 4,
            }}
          >
            <Typography
              variant="h3"
              fontWeight={600}
              sx={{
                flex: 1,
                textAlign: "center",
              }}
            >
              {programTitle}
            </Typography>

            {programDetails?.program?.programLogo && (
              <Box
                sx={{
                  position: "absolute",
                  left: 0,
                }}
              >
                <img
                  src={`${programDetails?.program?.programLogo}`}
                  alt={programDetails?.program?.name}
                  style={{
                    height: "130px",
                    objectFit: "contain",
                    borderRadius: "8px",
                  }}
                />
              </Box>
            )}


            {isLoggedIn &&
              <>
                <Tooltip title="Program Options">
                  <IconButton onClick={handleClick}>
                    <MoreVertIcon />
                  </IconButton>
                </Tooltip>

                <Menu anchorEl={anchorE2} open={anchorE2} onClose={handleClose}>

                  <MenuItem onClick={() => navigate(`/editProgram/${programDetails?.program?._id}`)}>Update Program</MenuItem>

                  <MenuItem onClick={() => handleDeleteClick()}>Delete Program</MenuItem>
                </Menu>
              </>
            }
          </Box>

          <Grid
            container
            spacing={3}
            sx={{
              mt: 3,
              justifyContent: "center",
            }}
          >
            <Grid item xs={12} md={6}>
              <Box
                sx={{
                  p: 3,
                  border: "1px solid #e0e0e0",
                  borderRadius: "8px",
                  backgroundColor: theme.palette.background.figma,
                  height: "100%",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    mb: 2,
                  }}
                >
                  <Typography
                    sx={{
                      fontWeight: 600,
                      color: "text.primary",
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                    }}
                  >
                    <DescriptionIcon />
                    <u>Program Details</u>
                  </Typography>

                  <Button
                    variant="contained"
                    size="small"
                    sx={{
                      borderRadius: "50%",
                      minWidth: 36,
                      height: 36,
                      p: 0,
                      backgroundColor: theme.palette.primary.main,
                      "&:hover": {
                        backgroundColor: theme.palette.secondary.figma,
                      },
                    }}
                    onClick={() => {
                      setModalOpen(true);
                      setSelectedFile(`${programDetails.program.descriptionFile}`)

                    }}
                  >
                    <ReadMoreOutlinedIcon />
                  </Button>
                </Box>

                <Typography variant="body2">
                  {programDetails?.program?.description}
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={12} md={6}>
              <Box
                sx={{
                  p: 3,
                  border: "1px solid #e0e0e0",
                  borderRadius: "8px",
                  backgroundColor: theme.palette.background.figma,
                  height: "100%",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    mb: 2,
                  }}
                >
                  <Typography
                    sx={{
                      fontWeight: 600,
                      color: "text.primary",
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                    }}
                  >
                    <HowToRegOutlinedIcon />
                    <u>How to Join</u>
                  </Typography>

                  <Button
                    variant="contained"
                    size="small"
                    sx={{
                      borderRadius: "50%",
                      minWidth: 36,
                      height: 36,
                      p: 0,
                      backgroundColor: theme.palette.primary.main,
                      "&:hover": {
                        backgroundColor: theme.palette.secondary.figma,
                      },
                    }}
                    onClick={() => {
                      setModalOpen(true);
                      setSelectedFile(`${programDetails.program.howToJoin.file}`)


                    }}
                  >
                    <ReadMoreOutlinedIcon />
                  </Button>
                </Box>

                <Typography variant="body2">
                  {programDetails?.program?.howToJoin.text}
                </Typography>
              </Box>
            </Grid>
          </Grid>


        </Box>

        <Box sx={{ my: 5 }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2,
            }}
          >
            <Typography fontWeight={700}>Media Gallery</Typography>

            {isLoggedIn && (
              <IconButton
                onClick={() => {
                  if (
                    folders.length >=
                    programDetails?.program?.folderLimit
                  ) {
                    message.error("Folder limit reached.");
                    return;
                  }
                  setIsCreateFolderOpen(true);
                  setFolderName("");
                  setSelectedIcon("folder");
                  setSelectedColor(colorOptions[0]);
                }}
                sx={{
                  border: `1px dashed ${theme.palette.primary.main}`,
                  color: theme.palette.primary.main,
                }}
              >
                <CreateNewFolderIcon />
              </IconButton>
            )}
          </Box>

          <Grid container spacing={3}>
            {folders.length > 0 ? (
              folders.map((folder) => {
                const IconComponent =
                  ICON_OPTIONS.find((i) => i.key === folder.icon)?.icon ||
                  FolderOutlined;

                return (
                  <Grid item xs={6} sm={4} md={3} lg={2} key={folder._id}>
                    <Paper
                      onClick={() => {
                        const encodedProgramName = encodeURIComponent(
                          (currentProgram?.name || "").trim(),
                        );

                        if (hideSelectors && !isLoggedIn) {
                          navigate(
                            `/${encodedProgramName}/folders/${folder._id}`,
                          );
                          return;
                        }
                        navigate(
                          `/programs/${encodedProgramName}/folders/${folder._id}`,
                          {
                            state: {
                              programName: programDetails.program.name
                            }
                          }
                        );
                      }}
                      elevation={0}
                      sx={{
                        backgroundColor: folder.color || "#1976d2",
                        cursor: "pointer",
                        p: 2,
                        height: 120,
                        borderRadius: 3,
                        border: "1px solid",
                        borderColor: "divider",
                        position: "relative",
                        transition: "all 0.25s ease",
                        "&:hover": {
                          boxShadow: 6,
                          transform: "translateY(-4px)",
                          borderColor: "primary.main",
                        },
                      }}
                    >
                      {isLoggedIn && (
                        <IconButton
                          size="small"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleMenuOpen(e, folder);
                          }}
                          sx={{
                            position: "absolute",
                            top: 8,
                            right: 8,
                            color: "#fff",
                          }}
                        >
                          <MoreVertIcon fontSize="small" />
                        </IconButton>
                      )}

                      <Box
                        sx={{
                          height: "100%",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          color: "#fff",
                          gap: 1,
                        }}
                      >
                        <IconComponent sx={{ fontSize: 34 }} />
                        <Typography
                          fontWeight={600}
                          sx={{
                            textAlign: "center",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            maxWidth: "100%",
                          }}
                        >
                          {folder.name}
                        </Typography>
                      </Box>

                      {folder?.updatedAt && (
                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                          <Typography variant='caption' color='text.secondary'>Last updated: {new Date(folder.updatedAt).toLocaleDateString("en-GB")}</Typography>
                        </Box>
                      )}
                    </Paper>
                  </Grid>
                );
              })
            ) : (
              <Box sx={{ position: "relative", left: "50%" }}>
                <h3>No Folder Available</h3>
              </Box>
            )}
          </Grid>
        </Box>

        <Dialog
          open={isCreateFolderOpen}
          onClose={() => setIsCreateFolderOpen(false)}
          maxWidth="xs"
          fullWidth
        >
          <DialogTitle sx={{ fontWeight: 600 }}>
            Create Folder
            <IconButton
              onClick={() => setIsCreateFolderOpen(false)}
              sx={{ position: "absolute", right: 8, top: 8 }}
            >
              <Close />
            </IconButton>
          </DialogTitle>

          <DialogContent dividers>
            {/* Folder Name */}
            <Box sx={{ mb: 3 }}>
              <Typography variant="subtitle2" sx={{ mb: 0.5 }}>
                Folder Name
              </Typography>
              <TextField
                fullWidth
                size="small"
                placeholder="Enter folder name"
                value={folderName}
                onChange={(e) => setFolderName(e.target.value)}
              />
            </Box>

            {/* Icon Picker */}
            <Box sx={{ mb: 3 }}>
              <Typography variant="subtitle2" sx={{ mb: 1 }}>
                Choose Icon
              </Typography>

              <Grid container spacing={1}>
                {ICON_OPTIONS.map(({ key, label, icon: IconComp }) => (
                  <Grid item xs={3} key={key}>
                    <Paper
                      onClick={() => setSelectedIcon(key)}
                      sx={{
                        p: 1,
                        textAlign: "center",
                        cursor: "pointer",
                        borderRadius: 2,
                        border:
                          selectedIcon === key
                            ? "2px solid"
                            : "1px solid transparent",
                        borderColor: "primary.main",
                        "&:hover": {
                          bgcolor: "action.hover",
                        },
                      }}
                    >
                      <IconComp
                        sx={{
                          fontSize: 26,
                          color:
                            selectedIcon === key
                              ? "primary.main"
                              : "text.secondary",
                        }}
                      />
                      <Typography variant="caption" display="block">
                        {label}
                      </Typography>

                    </Paper>
                  </Grid>
                ))}
              </Grid>
            </Box>

            {/* Color Picker */}
            <Box sx={{ mb: 3 }}>
              <Typography variant="subtitle2" sx={{ mb: 1 }}>
                Choose Color
              </Typography>

              <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
                {colorOptions.map((color) => (
                  <Box
                    key={color}
                    onClick={() => setSelectedColor(color)}
                    sx={{
                      width: 32,
                      height: 32,
                      borderRadius: 1,
                      backgroundColor: color,
                      cursor: "pointer",
                      border:
                        selectedColor === color
                          ? "3px solid #000"
                          : "1px solid #ccc",
                    }}
                  />
                ))}
              </Box>
            </Box>

            <Box sx={{ mb: 3 }}>
              <Typography variant="subtitle2" sx={{ mb: 0.5 }}>
                Folder Visibility
              </Typography>

              <TextField
                select
                fullWidth
                size="small"
                value={visibility}
                onChange={(e) => setVisibility(e.target.value)}
              >
                <MenuItem value="PUBLIC">Public (Visible to all)</MenuItem>
                <MenuItem value="PRIVATE">Private (Admin only)</MenuItem>
              </TextField>
            </Box>
          </DialogContent>

          <DialogActions>
            <Button onClick={() => setIsCreateFolderOpen(false)}>Cancel</Button>
            <Button
              variant="contained"
              disabled={!folderName.trim() || loading}
              onClick={handleCreateFolder}
            >
              Create Folder
            </Button>
          </DialogActions>
        </Dialog>



        {/* Delete Folder Dialog */}
        <Dialog
          open={openFolderPopUp}
          onClose={handleDelete}
        >
          <DialogTitle>Delete Folder</DialogTitle>
          <DialogContent>
            <Typography>
              Are you sure you want to delete this folder?
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
              This will permanently delete all media files inside this folder.
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => {
              setOpenFolderPopUp(false);
              setAnchorEl(null);
            }}>Cancel</Button>
            <Button color="error" onClick={handleConfirmDelete}>
              Delete
            </Button>
          </DialogActions>
        </Dialog>
        {/* Popover for Update/Delete */}
        <Popover
          open={Boolean(anchorEl)}
          anchorEl={anchorEl}
          onClose={handleMenuClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        >
          <MenuItem
            onClick={() => {
              handleUpdateClick();
              handleMenuClose();
            }}
          >
            Update
          </MenuItem>
          <MenuItem onClick={() => {
            setOpenFolderPopUp(true);
            handleDelete();
          }} sx={{ color: "error.main" }}>
            Delete Folder
          </MenuItem>
        </Popover>
        {/* Update Folder Dialog */}
        <Dialog
          open={openUpdateDialog}
          onClose={() => setOpenUpdateDialog(false)}
          maxWidth="xs"
          fullWidth
        >
          <DialogTitle sx={{ fontWeight: 600 }}>
            Update Folder
            <IconButton
              onClick={() => setOpenUpdateDialog(false)}
              sx={{ position: "absolute", right: 8, top: 8 }}
            >
              <Close />
            </IconButton>
          </DialogTitle>

          <DialogContent dividers>
            {/* Folder Name */}
            <Box sx={{ mb: 3 }}>
              <Typography variant="subtitle2" sx={{ mb: 0.5 }}>
                Folder Name
              </Typography>
              <TextField
                fullWidth
                size="small"
                placeholder="Enter folder name"
                value={folderName}
                onChange={(e) => setFolderName(e.target.value)}
              />
            </Box>

            {/* Icon Picker */}
            <Box sx={{ mb: 3 }}>
              <Typography variant="subtitle2" sx={{ mb: 1 }}>
                Choose Icon
              </Typography>

              <Grid container spacing={1}>
                {ICON_OPTIONS.map(({ key, label, icon: IconComp }) => (
                  <Grid item xs={3} key={key}>
                    <Paper
                      onClick={() => setSelectedIcon(key)}
                      sx={{
                        p: 1,
                        textAlign: "center",
                        cursor: "pointer",
                        borderRadius: 2,
                        border:
                          selectedIcon === key
                            ? "2px solid"
                            : "1px solid transparent",
                        borderColor: "primary.main",
                        "&:hover": {
                          bgcolor: "action.hover",
                        },
                      }}
                    >
                      <IconComp
                        sx={{
                          fontSize: 26,
                          color:
                            selectedIcon === key
                              ? "primary.main"
                              : "text.secondary",
                        }}
                      />
                      <Typography variant="caption" display="block">
                        {label}
                      </Typography>

                    </Paper>
                  </Grid>
                ))}
              </Grid>
            </Box>

            {/* Color Picker */}
            <Box sx={{ mb: 3 }}>
              <Typography variant="subtitle2" sx={{ mb: 1 }}>
                Choose Color
              </Typography>

              <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
                {colorOptions.map((color) => (
                  <Box
                    key={color}
                    onClick={() => setSelectedColor(color)}
                    sx={{
                      width: 32,
                      height: 32,
                      borderRadius: 1,
                      backgroundColor: color,
                      cursor: "pointer",
                      border:
                        selectedColor === color
                          ? "3px solid #000"
                          : "1px solid #ccc",
                    }}
                  />
                ))}
              </Box>
              <Box sx={{ mb: 3 }}>
                <Typography variant="subtitle2" sx={{ mb: 0.5 }}>
                  Folder Visibility
                </Typography>

                <TextField
                  select
                  fullWidth
                  size="small"
                  value={visibility}
                  onChange={(e) => setVisibility(e.target.value)}
                >
                  <MenuItem value="PUBLIC">Public (Visible to all)</MenuItem>
                  <MenuItem value="PRIVATE">Private (Admin only)</MenuItem>
                </TextField>
              </Box>
            </Box>
          </DialogContent>

          <DialogActions>
            <Button onClick={() => setOpenUpdateDialog(false)}>Cancel</Button>
            <Button
              variant="contained"
              disabled={!folderName.trim() || loading}
              onClick={handleUpdateFolder}
            >
              Update Folder
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={modalOpen}
          onClose={() => setModalOpen(false)}
          maxWidth="md"
          fullWidth
        >
          <DialogTitle>
            <IconButton
              aria-label="close"
              onClick={() => setModalOpen(false)}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <Close />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <iframe
              src={selectedFile}
              width="100%"
              height="400px"
              style={{ border: "none" }}
              title="PDF Viewer"
            />
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => setModalOpen(false)}
              color="primary"
              variant="contained"
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>



        <Dialog open={openDeleteDialog}
          onClose={() => setOpenDeleteDialog(false)}
          maxWidth="sm"
          fullWidth >
          <DialogTitle sx={{ fontWeight: 600, color: "error.main" }}>
            Delete Program
          </DialogTitle>
          <DialogContent>
            <Typography sx={{ mb: 1 }}> Are you sure you want to delete this program? </Typography>
            <Typography color="error" sx={{ fontSize: "14px" }}>
              This will also delete all associated folders and media inside it. This action cannot be undone.
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenDeleteDialog(false)}> Cancel </Button>
            <Button variant="contained" color="error" onClick={handleConfirmDeleteProgram} > Delete </Button>
          </DialogActions>
        </Dialog>
      </Box> 

      {programUpdatedAt && (
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
          <Typography variant='caption' color='text.secondary'>Last updated: {new Date(programUpdatedAt).toLocaleDateString("en-GB")}</Typography>
        </Box>
      )}
    </Paper>
  );
};

export default SingleProgramPage2;











